import React from 'react'
import queryString from 'query-string'
import { Loading, MarkdownText, Modal } from 'components'


const SourceModal = ({
  categoryCode,
  days,
  id,
  question,
  source,
  source_content,
  subcategory,
  is_mobile,
  onSourceGetRequest,
  onSourceSet,
  onSourceReset,
}) => {
  let content = <Loading />;

  if (source_content) {
    content = (
      <>
        <div
          className='ua-txt-btn txt-semibold'
          onClick={onSourceReset}
        >
          <span className='show-more-icon elegant elegant-eleganticons-19'/>

          <span>回上頁</span>
        </div>

        <div className='source-content'>
          <MarkdownText children={source_content} />
        </div>
      </>
    );
  } else {
    if (source.includes('pdf') || source.includes('transcript')) {
      const title = (source.includes('pdf')) ? 'PDF' : 'Transcript';
      const onClick = () => {
        if (source.includes('pdf')) {
          window.open(source, 'new');
        } else {
          (async () => {
            const res = await fetch(source);
            const json = await res.json();
            const sourceContent = json.transcript.text;

            onSourceSet(sourceContent);
          })();
        }
      };

      content = (
        <div
          className='ua-txt-btn txt-semibold'
          onClick={onClick}
        >
          <span>{title}</span>

          <span className='show-more-icon elegant elegant-eleganticons-20'/>
        </div>
      );
    } else {
      const data = {
        category: categoryCode,
        code: subcategory,
        days: days,
        question: question,
      };

      let list = [];

      if (source.includes('\n')) {
        const arr = source.split('\n');

        for (let i = 0; i < arr.length; i++) {
          const title = arr[i];
          const onClick = () => {
            data.title = title;

            let request = JSON.stringify(data);
            request = queryString.stringify({ data: request });

            onSourceGetRequest(request);
          };

          list[list.length] = (
            <p className='ua-txt-btn txt-semibold' onClick={onClick} key={i}>
              <span>{title}</span>

              <span className='show-more-icon elegant elegant-eleganticons-20'/>
            </p>
          );
        }
      } else {
        const onClick = () => {
          data.title = source;

          let request = JSON.stringify(data);
          request = queryString.stringify({ data: request });

          onSourceGetRequest(request);
        };

        list = [
          <p className='ua-txt-btn txt-semibold' onClick={onClick} key='0'>
            <span>{source}</span>

            <span className='show-more-icon elegant elegant-eleganticons-20'/>
          </p>
        ];
      }

      content = <div className='source-list'>{list}</div>;
    }
  }

  return (
    <Modal
      id={id}
      customClassName='source-modal'
      title='原文出處'
      html={<div className={`source`}>{content}</div>}
      fullHeight={is_mobile}
      callback={onSourceReset}
    />
  );
};


export { SourceModal }
